jQuery(document).ready(function($) {
  // Handle toast logic
  $('.container__toast').each(function() {
    var $this = $(this);
    var openAfter = $this.data('open-after');
    var randomMin = $this.data('number-min');
    var randomMax = $this.data('number-max');
    var randomNumber = Math.floor(Math.random() * randomMax) + randomMin;

    // Convert to ms
    openAfter = openAfter * 1000;

    $this.find('.number--viewed').text(randomNumber);

    setTimeout(function() {
      $this.addClass('active');
    }, openAfter);
  });

  // Handle countdown timer logic
  $('.container__countdown').each(function() {
    var $this = $(this);
    var timeUntil = $this.data('count-until');
    var targetTime = new Date(timeUntil).getTime();

    // Function to immediately update the countdown
    function updateCountdown() {
      var now = new Date().getTime();
      var distance = targetTime - now;

      // Time calculations for days, hours, minutes, and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      var displayTime = '';
      if (days > 0) displayTime += days + 'd ';
      if (hours > 0) displayTime += hours + 'h ';
      if (minutes > 0) displayTime += minutes + 'm ';
      if (seconds > 0) displayTime += seconds + 's ';

      // Display the calculated time
      $this.find('.countdown__time').text(displayTime);

      // If the countdown is finished, display 'EXPIRED'
      if (distance < 0) {
        clearInterval(x);
        $this.find('.countdown__time').text('EXPIRED');
      }
    }

    updateCountdown();

    // Continue to update the countdown every second
    var x = setInterval(updateCountdown, 1000);
  });
});
